import { call, put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { requestPuppy } from '@wix/da-http-client';
import { actions } from '../../Stream';
import {
  getCurrentMediaSource,
  getNonManageablePrependedGallectionsCount,
  getCurrentFolderId,
  getGrusername,
} from '../selectors';
import { getGallectionStreamId, getGallectionType } from '../helpers';
import type { Action } from 'redux-actions';
import type { MoveGallectionToPositionPayload } from '../actions';
import type { PapiRequestDaSharedGallectionFoldersUpdateOrder } from '@wix/da-papi-types';

function* moveGallectionToPosition(
  action: Action<MoveGallectionToPositionPayload>
): SagaIterator {
  const { folderId, position, moveType } = action.payload!;
  const username: ReturnType<typeof getGrusername> = yield select(
    getGrusername
  );
  const mediaSource: ReturnType<typeof getCurrentMediaSource> = yield select(
    getCurrentMediaSource
  );
  const currentFolderId: ReturnType<typeof getCurrentFolderId> = yield select(
    getCurrentFolderId
  );
  const nonManageablePrependedGallectionsCount: ReturnType<
    typeof getNonManageablePrependedGallectionsCount
  > = yield select(getNonManageablePrependedGallectionsCount);
  const streamId = getGallectionStreamId(mediaSource, currentFolderId);

  if (!moveType || moveType === 'streamOnly') {
    yield put(actions.moveItem({ streamId, item: folderId, position }));
  }

  if (!moveType || moveType === 'papiOnly') {
    const params: PapiRequestDaSharedGallectionFoldersUpdateOrder = {
      username,
      folderid: folderId,
      type: getGallectionType(mediaSource) ?? 'collection',
      position: position - nonManageablePrependedGallectionsCount, // because All, Featured folders are prepended immovable objects that do not reserve a spot on the BE
    };

    yield call(requestPuppy, {
      method: 'post',
      url: 'gallection/folders/update_order',
      data: params,
    });
  }
}

export default moveGallectionToPosition;
